// extracted by mini-css-extract-plugin
export default {"CancelAction":"CancelAction_CancelAction ConfirmAction_ConfirmAction"};